import {
  Alert,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { apiResponse } from "../../redux/reducer/apiReducer";
import { AuthContext } from "./AuthContext";
import Loader from "../../component/Loader";
import PopUpAlert from "../../component/PopUpAlert";
import loginImg from '../../assets/images/locksmith.png'
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import ReCAPTCHA from "react-google-recaptcha";
import { AuthAPI } from "../../api/AuthAPI";
const MemberLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { memberSignIn, isLoading, message } = useContext(AuthContext);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [tempPassword, setTempPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showTempPassword, setShowTempPassword] = useState(false);
  const [passwordValidate, setPasswordValidate] = useState({ length: false, specialSymbal: false, allowedChars:false, number: false, upperLetter: false, lowerLetter:false })
    const [errors, setErrors] = useState({
    username: false,
    newPassword: false,
    tempPassword: false,
    isNewPasswordEmpty: false,
  });
  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowTempPassword = () => setShowTempPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const handleUserName = (e) => {
    setErrors({});
    setUsername(e.target.value);
  };

  const handleNewPassword = (event) => {
    setErrors({});
    const { value } = event.target;
    const uppercasePattern = /[A-Z]/;
    const lowercasePattern = /[a-z]/;
    const numberPattern    = /[0-9]/;
    // Exactly one of ! @ $ *
    const specialCharPattern = /[!@$*]/; 
    const allowedCharsPattern = /^[A-Za-z0-9!@$*]+$/;
    let template = {}
    if (uppercasePattern.test(value)) {
      template.upperLetter = true;
    }
    if (lowercasePattern.test(value)) {
      template.lowerLetter = true;
    }
    if (specialCharPattern.test(value)) {
      template.specialSymbal = true;
    }
    if (allowedCharsPattern.test(value)) {
      template.allowedChars = true;
    }
    if (numberPattern.test(value)) {
      template.number = true;
    }
    if (value?.length >= 8 && value?.length <= 20) {
      template.length = true;
    }
    setPasswordValidate(template);
    setNewPassword(value);
  };
  const handleTempPassword = (e) => {
    setErrors({});
    setTempPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let errorFields = {};
      if (!username.trim()) {
        errorFields.username = true;
      }
      if (!newPassword.trim()) {
        errorFields.isNewPasswordEmpty = true
      }
      if (!passwordValidate.length || !passwordValidate.number || 
        !passwordValidate.specialSymbal || !passwordValidate.allowedChars || !passwordValidate.lowerLetter ||
        !passwordValidate.upperLetter) {
        errorFields.newPassword = true;
      }
      if (!tempPassword.trim()) {
        errorFields.tempPassword = true;
      }
      setErrors(errorFields);
      if (!username.trim() || !newPassword.trim() || !tempPassword.trim() || !passwordValidate.length || !passwordValidate.number || !passwordValidate.specialSymbal || !passwordValidate.upperLetter) {
        return;
      }
      const loginDetails = {
        email: username.trim(),
        tmpPassword: tempPassword.trim(),
        password: newPassword.trim()
      }
      const res = await memberSignIn(loginDetails);
      
      if (res?.status === 200) {
        navigate("/");
      }
    } catch (err) {
      setIsLoading(false);
      console.error(err);

      setMessage({ type: 'error', content: err?.response?.data?.Data });
    }
  };
  const verifyCaptcha = async (data) => {
    try {
      const response = await AuthAPI.postVerifyCaptcha(data);
      setCaptchaVerified(response.Data);
    } catch (error) {

    }
  }
  return (
    <div className="login_container">
      {isLoading && <Loader />}
      <PopUpAlert type={message.type} message={message.content} />
      <div className="login_form">
        <div className="login_header">
          <img src={loginImg} alt="" />
          <h2>Welcome back</h2>
          <p>Please enter details to sign in</p>
        </div>
        <div className="login_input_fields">
          <TextField
            error={errors.username}
            helperText={errors.username && "Email is required"}
            className="login-text-input"
            fullWidth
            variant="outlined"
            label="Email"
            onChange={(e) => handleUserName(e)}
          />
          <FormControl
            fullWidth
            className="login-text-input"
            error={errors.tempPassword}
            variant="outlined"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              Temporary Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showTempPassword ? "text" : "password"}
              onChange={(e) => handleTempPassword(e)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowTempPassword}
                    onMouseDown={handleMouseDownPassword}
                    onMouseUp={handleMouseUpPassword}
                    edge="end"
                  >
                    {showTempPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Temporary Password"
            />
            {errors.tempPassword && (
              <FormHelperText sx={{ color: "red" }}>
                {"Temporary password is required"}
              </FormHelperText>
            )}
          </FormControl>
          <FormControl
            fullWidth
            className="login-text-input"
            error={errors.newPassword || errors.isNewPasswordEmpty}
            variant="outlined"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              New Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showNewPassword ? "text" : "password"}
              onChange={(e) => handleNewPassword(e)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowNewPassword}
                    onMouseDown={handleMouseDownPassword}
                    onMouseUp={handleMouseUpPassword}
                    edge="end"
                  >
                    {showNewPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="New Password"
            />
            {errors.isNewPasswordEmpty && (
              <FormHelperText sx={{ color: "red" }}>
                {"New password is required"}
              </FormHelperText>
            )}
          </FormControl>
          <div className="password_validate_message_box">
          <p className={passwordValidate.upperLetter ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>

                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Require at least 1 Uppercase.
                </p>
                <p className={passwordValidate.lowerLetter ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>

                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Require at least 1 lowercase.
                </p>
                <p className={passwordValidate.specialSymbal ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Must include exactly one of: ! @ $ * (no other special characters).
                </p>
                <p className={passwordValidate.allowedChars ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    No other characters allowed.
                </p>
                <p className={passwordValidate.number ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Require at least 1 Number.
                </p>
                <p className={passwordValidate.length ?
                    "password_validate_message active" :
                    (errors['password']) ? "password_validate_message error" : "password_validate_message"}>
                    <IoMdCheckmarkCircleOutline className="password_validate_log" />
                    Minimum 8 and Maximum 20 characters.
                </p>
          </div>
        </div>
        <ReCAPTCHA
          style={{ marginTop: '20px' }}
          sitekey={import.meta.env.VITE_APP_CAPTCHA_SITE_KEY}
          onChange={(data) => verifyCaptcha(data)}
        />
        <div className="login_btn">
          <Button
            onClick={handleSubmit}
            disabled={!captchaVerified}
            fullWidth
            variant="contained">
            Sign in
          </Button>
        </div>
        <div className="login_privacy_policy">
          <p>By signing up, you agree to the Sportmingle <Link to={'https://sportmingle.com/terms_and_conditions.html'}>Term of Services</Link> and <Link to={'https://sportmingle.com/privacy_policy.html'}>Privacy Policy</Link></p>
        </div>
        <div className="login_create_account">
          <p>
            Don't have any account? <Link to={'/account-type'}>Create account</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MemberLogin;